<template>
	<div class="on_sale_table">
		<div class="table" >
			<div class="d-flex a-center w-100 j-sb" style="box-sizing: border-box;height: 80px;border-radius: 0.375rem;background-color: #FFFFFF;margin-bottom: 20px;padding: 0 40px;">
				<div class="d-flex a-center j-sb" style="width: 23.75rem;position: relative;font-weight: 600;box-sizing: border-box;padding: 0 0.375rem;">
					<div class="d-flex flex-column a-center" :class="curIndex==index?'tab-active':'tab-pt'" @click="tabclick(index)"
					style="box-sizing: border-box;cursor: pointer;" v-for="(item,index) in tabList" :key="index">
						<div style="font-size: 20px;">{{item.tabnum}}</div>
						<div style="margin-top: 9px;">{{item.tabname}}</div>
					</div>
					<div class="cld-box" :style="curIndex==0?'left:0':curIndex==1?'left:26.3%':curIndex==2?'left:56.3%':'left:86%'"></div>
				</div>
				<el-button type="primary" size="mini" style="background-color: #1E69FF;" @click="performance">业务员绩效表</el-button>
			</div>
			<el-table ref="multipleTable" :height="880" :border="false" @filter-change="filterSel" :data="tableData" tooltip-effect="dark"
				style="font-size: 0.75rem;" :header-cell-style="{color:'#000000'}" @selection-change="handleSelectionChange">
				<el-table-column align="center" type="selection" label="">
				</el-table-column>
				<el-table-column align="center" prop="try_id" label="序号" show-overflow-tooltip>
				</el-table-column>
				<el-table-column
				align="center" 
				label="类型" 
				prop="sp_type"
				show-overflow-tooltip
				:filters="sp_data"
				:filter-multiple="false"
				column-key="sp_type">
					<template slot-scope="scope">
						<div>{{scope.row.send_status==1?'未发送':'已发送'}}</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="salesman_name" label="业务员" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="name" label="申请人" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="mobile" label="电话" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="add_time" label="提交申请日期" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="matter_type" label="资料类型" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="r_type" label="接收方式" show-overflow-tooltip>
					<template slot-scope="scope">
						<div>{{scope.row.r_type==1?'微信发送':scope.row.r_type==2?'邮箱发送':'快递发送'}}</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="detail_time" label="申领提交日期" show-overflow-tooltip>
					<template slot-scope="scope">
						<div>{{scope.row.detail_time==''?'/':scope.row.detail_time}}</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="wx_number" label="微信号" v-if="curIndex==1" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="email" label="邮箱号" v-if="curIndex==2" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="address" label="操作" width="150">
					<el-button size="mini"
						style="background: #1E69FF;color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;"
						round @click="openDetail(scope.$index, scope.row)">详情</el-button>
				</el-table-column>
			</el-table>
			<footer class="d-flex j-sb a-center" >
				<el-button type="primary" size="mini" style="background-color: #1E69FF;" @click="finishMore">批量已完成</el-button>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, total" :total="total_records">
				</el-pagination>
			</footer>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				hzhbShow:false,
				m_id:'',
				curIndex:0,
				tableData:[],
				currentPage: 1, //初始页
				pageSize : 10,
				total_records : 0,
				status:'0',
				keyword:'',
				sp_data:[
					// {text:'全部',value:'0'},
					{text:'未发送', value:'1'},
					{text:'已发送', value:'2'}
				],
				type:1,
				tabList:[
					{
						tabname:'全部',
						tabnum:0,
						tabstate:0
					},{
						tabname:'微信发送',
						tabnum:0,
						tabstate:1
					},{
						tabname:'邮箱发送',
						tabnum:0,
						tabstate:2
					},{
						tabname:'快递发送',
						tabnum:0,
						tabstate:3
					}
				],
				review_content:'',
				percent:0,
				try_id:'',
				sp_type:'0',
				checkId:[]
			}
		},
		methods:{
			tabclick(index){
				this.curIndex=index
				this.currentPage=1
				this.admin_get_matter_apply_list()
			},
			/*获取顶部信息*/
			admin_get_matter_data(){
				let params = {
					act:'admin_get_matter_data',
					m_id:this.m_id,
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.admin_get_matter_data(params).then((res)=>{
					if(res.code==0){
						this.tabList[0].tabnum=res.data.num_a
						this.tabList[1].tabnum=res.data.num_b
						this.tabList[2].tabnum=res.data.num_c
						this.tabList[3].tabnum=res.data.num_d
					}
				})
			},
			admin_get_matter_apply_list(){
				let params = {
					act:'admin_get_matter_apply_list',
					m_id:this.m_id,
					status:this.curIndex,
					keyword:this.keyword,
					send_status:this.sp_type,
					page:this.currentPage,
					size:this.pageSize,
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.admin_get_matter_apply_list(params).then((res)=>{
					this.tableData=[]
					this.total_records=0
					this.tableData = res.data
				})
			},
			handleSizeChange(size) {
				this.pageSize = size;
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.admin_get_matter_apply_list()
			},
			filterSel(key,value){
				if(key.sp_type[0]){
					this.sp_type = key.sp_type[0]
				}else{
					this.sp_type = '0'
				}
				this.admin_get_matter_apply_list()
			},
			handleSelectionChange(val) {
				let arr = []
				val.forEach((item)=>{
					arr.push(item.custom_id)
				})
				this.checkId=arr
			},
			finishMore(){
				let params={
					act:'admin_batch_make_send',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					apply_ids: this.checkId.join(',')
				}
				this.$api.admin_batch_make_send(param).then((res)=>{
					if(res.code==0){
						this.$message({
							showClose: false,
							message: '操作成功',
							type: 'success',
							offset: 350
						})
						this.admin_get_matter_data()
						this.admin_get_matter_apply_list()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			openDetail(index,row){
				this.$router.push({path:'wl_sl_detail',query:row})
			},
			performance(){
				this.$router.push({path:'wl_man_list',query:this.m_id})
			}
		},
		created() {
			this.m_id = this.$route.query.m_id
			this.admin_get_matter_data()
			this.admin_get_matter_apply_list()
		}
	}
</script>

<style scoped>
	.tab-active{
		color: #1E69FF;
		font-size: 14px;
	}
	.tab-pt{
		color: #000000;
		font-size: 14px;
	}
	.cld-box{
		position: absolute;
		bottom: 0;
		width: 40px;
		height: 2px;
		background: #1E69FF;
		transition: .3s all;
		bottom: -6px;
	}
	.on_sale_table{
		width: 100%;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.table {
		margin-top: 1.44rem;
		width: 87.5rem;
		height: 100%;
		background: #E6E9ED;
		overflow: hidden;
		padding: 1.25rem;
		border-radius: 0.375rem;
	}
	footer {
		width: 87.5rem;
		height: 3.85rem;
		background: #FFFFFF;
		padding: 0 1.25rem;
		box-sizing: border-box;
		border-radius:0 0 0.375rem 0.375rem;
	}
	.all{
		box-sizing: border-box;
		border:1px solid #205DFF;
		color: #205DFF;
		background-color: #FFFFFF;
	}
	.all-active{
		background-color: #205DFF;
		color: #FFFFFF;
		box-sizing: border-box;
	}
</style>